import CapabilitiesPage from "./capabilities.page"
export default CapabilitiesPage;
